import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-milestone",
  "use": "icon-milestone-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-milestone\"><g><path stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" d=\"M5.5 2v14M5.5 2l9.345 4M5.5 10l9.345-4\" /><path d=\"M5.5 2v7.709L14.504 6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol